.root {
  width: 100%;
}

.popup {
  :global {
    .ant-picker-date-panel {
      width: 310px;
    }

    .ant-picker-date-panel .ant-picker-body {
      display: flex;
      justify-content: end;
      padding-right: 5px;
      padding-left: 45px;
    }
  }
}

.weekNumber {
  position: absolute;
  top: -3px;
  left: -40px;
  width: 28px;
  height: 30px;
  background-color: var(--x-color-background-lighter);
  color: rgba(0, 0, 0, 0.45);
  line-height: 30px;
  pointer-events: none;
}

:global(.ant-picker-cell.ant-picker-cell-in-view:not(.ant-picker-cell-selected)) {
  .nonWorkingDay {
    color: var(--x-color-text-red);
  }
}

:global(.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected) {
  .nonWorkingDay {
    background-color: var(--x-color-action-red-disabled);
  }
}

.hidePlaceholder {
  input {
    &::placeholder {
      color: transparent;
    }
  }
}
